import { render, staticRenderFns } from "./file-delete.vue?vue&type=template&id=1461576f&"
import script from "./file-delete.vue?vue&type=script&lang=js&"
export * from "./file-delete.vue?vue&type=script&lang=js&"
import style0 from "./file-delete.vue?vue&type=style&index=0&id=1461576f&prod&lang=less&module=true&"




function injectStyles (context) {
  
  this["$style"] = (style0.locals || style0)

}

/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  injectStyles,
  null,
  null
  
)

export default component.exports